/* tslint:disable */
/* eslint-disable */
export enum UserStackholderTypes {
  Stackholder = 'Stackholder',
  Company = 'Company'
}
